module.exports = __webpack_public_path__ + "img/brand_name_illustration.a29593ae.svg";